<template>
  <div class="colophon-overlay" @click="close">
    <div class="colophon-popup" @click.stop>
      <button class="close-btn" @click="close">x</button>
      <div class="colophon-content">
        <h2>About this archive</h2>
        <b>The Restroom Archive</b> is an ongoing case study that aims to
        document and celebrate the public restroom. What started as a joke in
        2023 has become a years-long practice of 3D scanning the restrooms in
        restaurants, gas stations, convenience stores, coffee shops, and various
        other spaces across the U.S. and Europe. The scans are meant to capture
        the humorous, chaotic, and often scary nature of these uniquely private
        publicly accessible spaces. Through capturing the diverse decor,
        graffiti, and artifacts, both stored and left behind, I consider public
        restrooms to be a reflection of both the creativity and impertinence of
        human nature when we think nobody else is watching.
        <br />
        <br />
        Scans were made with LiDAR using Polycam for iPhone. This site was built
        using Vue.js and Three.js and is currently hosted on GitHub pages.
        <br />
        <br />
        For any feedback or questions please feel free to reach out through my
        <a href="https://jakewelch.design" target="_blank">website</a> or my
        <a href="https://instagram.com/jake___welch" target="_blank"
          >Instagram</a
        >. Thanks for visiting!
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'About-this-site',
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>
  h2 {
    /* color: var(--color-1-solid); */
    color: white;
    font-family: satoshi;
    font-size: 18px;
    text-align: center;
    /* text-decoration: underline; */
  }

  .colophon-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .colophon-popup {
    /* background: var(--color-2-transparent); */
    background: rgba(255, 255, 255, 0.11);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    color: white;
    /* padding: 20px; */
    /* border-radius: 15px; */
    max-width: 400px;
    width: 90%;
    box-shadow: 0 4px 6px rgba(color-1-transparent);
    border: 1px solid rgba(255, 255, 255, 0.3);
    position: relative;
  }

  .colophon-content {
    font-family: satoshi;
    font-size: 14px;
    color: white;
    padding: 1.5rem;
    padding-top: 0;
  }

  .colophon-content a {
    color: white;
    background-color: black;
    text-decoration: none;
    padding: 0 0.25em;
  }

  .colophon-content a:hover {
    background-color: red;
    color: white;
  }

  .close-btn {
    font-family: satoshi;
    position: absolute;
    top: 0.25em;
    right: 0.5em;
    color: white;
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }

  .close-btn:hover {
    color: red;
  }
</style>
